<app-schedule-documents-list
    [documents]="schedule.documents"
    [indicationId]="indicationId"
    (statusChanged)="attached.emit()">
</app-schedule-documents-list>

<form [formGroup]="form" (ngSubmit)="save()">
    <div class="row row--split">
        <app-form-field [control]="form.get('issuedAt')" fieldName="Data de Emissão do Laudo" class="date-field">
            <label>Data de Emissão do Laudo</label>
            <app-datepicker-single formControlName="issuedAt" [max]="today"></app-datepicker-single>
        </app-form-field>

        <app-form-field [control]="form.get('issuedAtTime')" fieldName="Hora" class="time-field">
            <label>Hora</label>
            <input app-input type="time" formControlName="issuedAtTime" />
        </app-form-field>
    </div>

    <app-form-field [control]="form.get('url')" fieldName="URL/Link do Laudo" class="w-100 url-small">
        <label>URL/Link do Laudo</label>
        <textarea app-input formControlName="url" rows="2"
            placeholder="Cole aqui o link completo do laudo"></textarea>
    </app-form-field>

    <app-form-field [control]="form.get('observation')" fieldName="Observações" class="w-100">
        <label>Observações (opcional)</label>
        <textarea app-input formControlName="observation" class="w-100-textarea" maxlength="500" rows="3"
            placeholder="Ex: Laudo de atendimento presencial realizado em..."></textarea>
    </app-form-field>
    <span class="field-hint field-hint--end">{{ form.get('observation')?.value?.length || 0 }}/500</span>

    <div class="actions">
        <button app-button type="button" appearance="tonal" color="info" (click)="preview()"
            matTooltip="Abre o laudo em uma nova guia para conferência" matTooltipPosition="above">
            Conferir Laudo
        </button>
        <button app-button type="submit" appearance="filled" color="success" [disabled]="saving">
            {{ saving ? 'Salvando...' : 'Salvar' }}
        </button>
    </div>
</form>
